import {get} from '@yandex-delivery/utils'
import type {FC} from 'react'

import {useMapComponents} from './use-map-components'

export const useMapComponent = <T>(componentName: string): FC<T> | null => {
  const components = useMapComponents()
  const Component = get(componentName, components)
  return Component ?? null
}
